<template>
  <div class="walkToDevelop">
    <div class="titleImg">
      <img :src="topImgUrl" style="width: 100%; height: 380px" />
    </div>
    <div class="main normalContainer">
      <div class="leftNavStyle">
        <leftNav
          :title="title"
          @currentNav="currentNav"
          :checkCurrentName="checkCurrentName"
        ></leftNav>
      </div>
      <div class="content">
        <div>
          <Breadcrumb :nowData="nowData"></Breadcrumb>
        </div>

        <router-view />
      </div>
    </div>
  </div>
</template>
<script setup>
import leftNav from '@/components/leftNav/index.vue';
import Breadcrumb from '@/components/Breadcrumb/index.vue';
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router';
import { useStore } from 'vuex';
const store = useStore();
import { onMounted, reactive, ref, watch } from 'vue';
let bannerList = reactive([]);
let nowData = ref('集团简介');
let checkCurrentName = ref('');
let title = reactive({
  bigName: '走进攀发展',
  // childName: ['集团简介', '企业文化', '领导班子'],
  childName: [
    { name: '集团简介', path: '/walktoDevelop' },
    { name: '企业文化', path: '/corporateCulture' },
    { name: '领导班子', path: '/leaders' },
    { name: '市属国有企业', path: '/sonCompany' },
  ],
});
let topImgUrl = ref('');
async function getBanner() {
  const res = await store.dispatch('getbanner/getbanner', 2);
  topImgUrl.value = res.data[0];
}
function currentNav(v) {
  console.log(v);
  nowData.value = v.data;
}
onMounted(() => {
  console.log(store.state.checkName);
  nowData.value = store.state.checkName;
  nowData.value = localStorage.getItem('nowData');
  checkCurrentName.value = store.state.checkName;
  console.log(checkCurrentName.value);
  getBanner();
});
onBeforeRouteUpdate((from, to) => {
  console.log(to);
  console.log(from);
  nowData.value = store.state.checkName;
  nowData.value = localStorage.getItem('nowData');
  checkCurrentName.value = store.state.checkName;
});
</script>
<style lang="less" scoped>
.walkToDevelop {
  margin-bottom: 68px;
  .main {
    display: flex;
    justify-content: space-between;
  }
  .leftNavStyle {
    margin-right: 60px;
  }
  .content {
    flex: 1;
  }
}
</style>
